import React from "react";

export default function AssetLocationCard()
{
    const inputStyle =
    {
        width: "100%",
        padding: "8px 12px",
        borderRadius: "7px",
        border: "1px solid #d9e1eb",
        background: "#ffffff",
        fontSize: "13px",
        outline: "none",
        boxSizing: "border-box"
    };

    const labelStyle =
    {
        fontSize: "10px",
        fontWeight: "bold",
        color: "#777",
        textTransform: "uppercase",
        letterSpacing: "1px",
        marginBottom: "4px"
    };

    const fieldContainer =
    {
        marginBottom: "14px"
    };

    return (

        <div
            style={{
                width: "100%",
                background: "#f7f9fc",
                border: "1px solid #e3e9f0",
                borderRadius: "14px",
                overflow: "hidden",
                boxShadow: "0 10px 24px rgba(0,0,0,.08)"
            }}
        >

            {/* ===================================================== */}
            {/* Header                                                */}
            {/* ===================================================== */}

            <div
                style={{
                    background: "#eef3f8",
                    borderBottom: "1px solid #dde4ec",
                    padding: "16px 22px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >

                <div
                    style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#333"
                    }}
                >
                    📍 Location
                </div>

                <div
                    style={{
                        background: "#eef6ff",
                        color: "#5a9bd6",
                        borderRadius: "999px",
                        padding: "5px 12px",
                        fontSize: "11px",
                        fontWeight: "bold"
                    }}
                >
                    Linked to Giraffe™
                </div>

            </div>

            {/* ===================================================== */}
            {/* Form                                                  */}
            {/* ===================================================== */}

            <div
                style={{
                    padding: "20px"
                }}
            >

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px"
                    }}
                >

                    <div style={fieldContainer}>
                        <div style={labelStyle}>Building</div>
                        <select style={inputStyle}>
                            <option>Broadcasting House</option>
                        </select>
                    </div>

                    <div style={fieldContainer}>
                        <div style={labelStyle}>Floor</div>
                        <select style={inputStyle}>
                            <option>Level 02</option>
                        </select>
                    </div>

                    <div style={fieldContainer}>
                        <div style={labelStyle}>Room</div>
                        <select style={inputStyle}>
                            <option>Meeting Room 2.15</option>
                        </select>
                    </div>

                    <div style={fieldContainer}>
                        <div style={labelStyle}>Zone</div>
                        <select style={inputStyle}>
                            <option>Ceiling</option>
                            <option>Wall</option>
                            <option>Floor</option>
                            <option>Plant</option>
                        </select>
                    </div>

                </div>

                <div style={fieldContainer}>

                    <div style={labelStyle}>
                        Location Description
                    </div>

                    <textarea
                        style={{
                            ...inputStyle,
                            resize: "vertical",
                            minHeight: "78px"
                        }}
                        defaultValue="Above suspended ceiling adjacent to north wall."
                    />

                </div>

            </div>

           

        </div>

    );
}